import { db } from "@/fstore";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

import router from "@/router";
import {
  stripe_payment_endpoint,
  subscription_group_endpoint
} from "@/defaults";
import axios from "axios";
import Bowser from "bowser";
import filter from "lodash/filter";

export default {
  new_show: ({ state }, show_obj) => {
    console.log("new_show: " + show_obj.key);
    var created_at = new Date().getTime();
    var update = {};
    update.key = show_obj.key;
    update.user = state.user.uid;
    update.user_email = state.user.email;
    update.created_at = created_at;
    update.updated_at = created_at;
    update.size = show_obj.size;
    update.bucketUrl = show_obj.bucketUrl;
    update.output_selected = show_obj.output_selected;
    update.output_width = show_obj.output_width;
    update.output_height = show_obj.output_height;
    update.zip_name = show_obj.zip_name;
    update.title = show_obj.title;
    update.show_stats = show_obj.show_stats;
    update.video_queued = true;
    update.video_completed = false;
    update.video_processing = false;
    update.video_processed = false;
    update.video_error = false;
    update.video_error_message = "";
    console.log(update);
    db.collection("shows")
      .doc(show_obj.key)
      .set(update);
    console.log("new_show: " + show_obj.key);
  },
  signup: ({ state }, login_obj) => {
    console.log(state.user);
    state.logging_in = true;
    state.initial_signup = true;
    state.signup_error = false;
    firebase
      .auth()
      .createUserWithEmailAndPassword(login_obj.email, login_obj.password)
      .then(function(credential) {
        // Success, now send user email verification immediately.
        console.log(credential);
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode, errorMessage);
        state.signup_error = true;
        if (errorCode === "auth/email-already-in-use") {
          // auth/email-already-in-use
          state.signup_error_message =
            "The email address is already in use by another account.";
        } else {
          state.signup_error_message = error.message;
        }
        // ...
      });
  },
  login: ({ state }, login_obj) => {
    console.log("login: " + login_obj.email + login_obj.password);
    console.log(state.user);
    state.logging_in = true;
    state.login_error = false;
    firebase
      .auth()
      .signInWithEmailAndPassword(login_obj.email, login_obj.password)
      .then(function(firebaseUser) {
        // Success
        console.log(firebaseUser);
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        state.login_error = true;
        if (errorCode === "auth/user-not-found") {
          // auth/user-not-found message is scary.
          state.login_error_message = "Email address provided not found.";
        } else {
          state.login_error_message = error.message;
        }

        console.log(errorCode, errorMessage);
        // ...
      });
  },
  send_reset: ({ state }, login_obj) => {
    console.log("send_reset: " + login_obj.email);
    console.log(state.user);
    state.reset_sent = false;
    state.reset_error = false;
    firebase
      .auth()
      .sendPasswordResetEmail(login_obj.email)
      .then(function(firebaseUser) {
        // Success
        console.log(firebaseUser);
        state.reset_sent = true;
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        state.reset_sent = false;
        state.reset_error = true;
        state.reset_error_message = errorMessage;
        console.log(errorCode, errorMessage);
        // ...
      });
  },
  redirectToShows: () => {
    console.log("redirectToShows");
    router.push({ name: "shows" });
  },
  sendEmailVerification: ({ state, dispatch }) => {
    state.user
      .sendEmailVerification()
      .then(function() {
        // Email sent.
        console.log("Email sent.");
        dispatch("toastMessage", {
          message: "Please check your email and verify with link.",
          title: "Email sent"
        });
      })
      .catch(function(error) {
        // An error happened.
        console.log("Error", error);
      });
  },
  sign_out: () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        // Reload after logout.
        location.reload();
      })
      .catch(err => alert(err.message || err));
  },
  create_sso: ({ state }, sso_obj) => {
    console.log("create_sso");
    var created_at = new Date().getTime();
    var update = {};
    update.uid = state.user.uid;
    update.email = state.user.email;
    update.sig = sso_obj.sig;
    update.payload = sso_obj.sso;
    update.created_at = created_at;
    update.ssoRoundTripId = sso_obj.ssoRoundTripId;
    console.log(update);
    db.collection("discourseSSO").add(update);
  },
  load_video_output_options: ({ state }) => {
    console.log("load_video_output_options");
    var docRef = db.collection("admin").doc("video_output_options");
    docRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          state.video_output_options = doc.data();
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
  },
  load_stripe_data: ({ state }) => {
    console.log("load_stripe_data");
    var customer_id = state.user_doc.customer;
    var endpoint = `${stripe_payment_endpoint}customer-charges/json/`;
    // endpoint = "http://127.0.0.1:5000/test/customer-charges/json/";
    // endpoint = "https://payments.soundslides.com/live/customer-charges/json/";
    axios
      .post(endpoint, {
        customer_id: customer_id
      })
      .then(res => {
        console.log(res.data);
        state.stripe_data = res.data.customer;
        state.stripe_data_charges = res.data.charges;
        state.stripe_data_draft_invoices = filter(
          res.data.recent_invoices.data,
          {
            status: "draft"
          }
        );
        state.stripe_data_due_invoices = filter(
          res.data.recent_invoices.data,
          i => {
            return i.status == "open" && !i.paid;
          }
        );
      });
  },
  set_stripe_auto_renewal: ({ state }, obj) => {
    console.log("set_stripe_auto_renewal");
    var endpoint = `${stripe_payment_endpoint}customer/${state.user.uid}/renewal/`;
    // Local Flask endpoint.
    // endpoint = `http://127.0.0.1:5000/test/customer/${
    //   state.user.uid
    // }/renewal/`;
    var subscription_id = obj.subscription_id;
    var disabled = obj.disabled;
    return axios
      .post(endpoint, {
        subscription_id: subscription_id,
        disabled: disabled
      })
      .then(res => {
        console.log(res.data);
        state.stripe_data = res.data;
      });
  },
  triggerLicenseSync: ({ state, dispatch }, retry) => {
    var uid = state.user.uid;
    var endpoint = `${subscription_group_endpoint}users/${uid}/sync/`;
    var timeout_ms = 3000;
    if (retry == false) {
      timeout_ms = 7000;
    }
    setTimeout(() => {
      axios
        .get(endpoint)
        .then(res => {
          console.log("triggerLicenseSync", res.data);
        })
        .catch(function(error) {
          if (error.response.status == 404) {
            // Retry after a few seconds.
            if (retry != false) {
              console.log("Wait again and retry ... could be first login.");
              dispatch("triggerLicenseSync", false);
            } else {
              console.log("Do not retry!");
            }
          }
        });
    }, timeout_ms);
  },
  update_newsletter: ({ state }, statusBoolean) => {
    var updated_at = new Date().getTime();
    var update = {};
    update.emailListSubscribed = statusBoolean;
    update.updated_at = updated_at;
    console.log(update);
    db.collection("users")
      .doc(state.user_doc.uid)
      .update(update);
  },
  updateBetaTesterProperty: ({ state }, statusBoolean) => {
    var updated_at = new Date().getTime();
    var update = {};
    update.beta_tester = statusBoolean;
    update.updated_at = updated_at;
    console.log(update);
    db.collection("users")
      .doc(state.user_doc.uid)
      .update(update);
  },
  markAccountClosed: ({ state, dispatch }) => {
    var updated_at = new Date().getTime();
    var update = {};
    update.closed = true;
    update.updated_at = updated_at;
    update.closed_at = updated_at;
    console.log(update);
    db.collection("users")
      .doc(state.user_doc.uid)
      .update(update);
    // If the user is subscribed, make sure the auto-renewal is disabled.
    if (state.user_doc.subscribed_source === "stripe") {
      var subscription_id = state.user_doc.stripe_result.id;
      dispatch("set_stripe_auto_renewal", {
        subscription_id: subscription_id,
        disabled: true
      });
    }
  },
  setUserDoc: ({ state, commit }, user_doc) => {
    commit("set_user_prefs", user_doc);
    // One-time check for legacy info (checks for hosting and legacy licenses).
    if (!user_doc.legacyHostingInfo) {
      // Check legacy hosting system for info and update.
      console.log("One-time check for legacy hosting.");
      var legacyHostingEndpoint = "https://legacy.soundslides.com/lookup/";
      axios
        .post(legacyHostingEndpoint, {
          email: state.user.email,
          uid: state.user.uid
        })
        .then(function(response) {
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  setBowser: ({ commit }) => {
    var _bowser = Bowser.getParser(window.navigator.userAgent);
    commit("setBowser", _bowser);
  },
  setBowserInitial: ({ state, dispatch }) => {
    dispatch("setBowser");
    // check for approval.
    if (!state.isApprovedBrowser) {
      dispatch("toastMessage", {
        variant: "info",
        title: "Browser Alert",
        to: { name: "help" },
        noAutoHide: true,
        message:
          "Your browser is dated. For best results, please use the latest Chrome or Firefox. \
          Click for system requirements."
      });
    }
  },
  toastMessage: function({ state }, message_obj) {
    if (typeof message_obj == "string") {
      // Just a simple message passed.
      state.componentInstance.$bvToast.toast(message_obj, {
        title: "Success",
        variant: "success",
        autoHideDelay: 3000,
        solid: true,
        toaster: "b-toaster-top-center"
      });
      return;
    }
    var autoHideDelayMs = 5000;
    var variant = message_obj.variant || "success";
    if (variant === "danger") {
      // Longer delay for error messages.
      autoHideDelayMs = 7000;
    }
    var toastSetup = {
      title: message_obj.title || "Alert",
      variant: variant,
      autoHideDelay: autoHideDelayMs,
      solid: true
    };
    if (message_obj.noAutoHide) {
      toastSetup.noAutoHide = true;
    }
    if (message_obj.to) {
      toastSetup.to = message_obj.to;
    }
    state.componentInstance.$bvToast.toast(message_obj.message, toastSetup);
  }
};
